import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class McuNotFound extends AlertLogic {
    static type = AlertType.McuNotFound;
    static category = AlertCategories.EQUIPMENT_FAILURE;
    static contentCategories = [ ContentCategories.SYSTEM_ERROR ];
    static title = Locale.gettext('MCU Not Found');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        // Varying across alert types
        let cardIllustration = 'pipes_emergency';
        let detailIcon = null;
        let lastSeen = alert.data?.OfflineDateTime ? this.locale.formatDateTime(new Date(alert?.data?.OfflineDateTime), false) : '';
        
        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('MCU Not Found'),
            cardDescription: this.locale.gettext('The Attendant was not able to communicate with the Hub board.'),
            cardIllustration: cardIllustration,
            //detailIcon: detailIcon,
            //detailTitle: this.locale.gettext('MCU Not Found'),
            detailDescription: this.locale.gettext('The Attendant was not able to communicate with the Hub board.'),
            detailDescription2: this.locale.gettext('Contact your pool maintainer or Poolside Tech Support for assistance.'),
            moreButton: false,
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('MCU Connection restored')
        });
        alertInfo.contentCategories = McuNotFound.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.Controllers[0];
        
        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            deviceId: 1,
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                
            }
        }) : null;
    }
}